export default (max) => Math.floor(Math.random() * max);
